<template>
  <router-view />
</template>

<script setup></script>
<style lang="css"></style>
